import script from "./ProjectCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCheck.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCheck.vue?vue&type=style&index=0&id=dbba4b48&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/spa-headless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbba4b48"]])

export default __exports__